<header class="header">
  <h1 class="header__title" translate="verification.routing.express"></h1>
  <btn
    [link]="true"
    (action)="promptSkip()"
    buttonText="common.btn.later"
    class="header__skip"
    data-e2e-element="verify-later.button"
  ></btn>
</header>
<card-wrapper>
  <form [formGroup]="form" (ngSubmit)="onSubmit()" method="POST" novalidate>
    <ng-container *ngrxLet="user$; let user">
      @if (!user.isEmailConfirmed) {
        <p [innerHTML]="'verification.steps' | translate: { stepsTotal: 2, currentStep: 1 }"></p>
      }
    </ng-container>
    <h2 class="title" translate="verification.basic.name.title"></h2>
    <p class="subtitle" translate="verification.basic.name.text-1"></p>

    @let ctxName = { focus: false, control: form.get('name'), field: 'name' };
    @if (ctxName) {
      <app-form-field
        [isControlTouched]="ctxName.control.touched"
        [errors]="ctxName.control.errors"
        [errorTexts]="fieldErrors[ctxName.field]"
        [submitErrors]="submitErrors.asObservable()"
      >
        <label
          [for]="ctxName.field"
          [class.fade-in]="ctxName.control.value || ctxName.focus"
          translate="profile-identity.field.name-2"
        ></label>
        <input
          [placeholder]="'profile-identity.field.name-2' | translate"
          [id]="ctxName.field"
          [autocomplete]="ctxName.field"
          [formControlName]="ctxName.field"
          [name]="ctxName.field"
          (focus)="ctxName.focus = true"
          (blur)="ctxName.focus = false"
          type="text"
          class="form-control"
          maxlength="64"
          data-e2e-element="identity.input.name"
        />
      </app-form-field>
    }

    @let ctxBirthDate = { focus: false, control: form.get('birthDate'), field: 'birthDate' };
    @if (ctxBirthDate) {
      <app-form-field
        [isControlTouched]="ctxBirthDate.control.touched"
        [errors]="ctxBirthDate.control.errors"
        [errorTexts]="fieldErrors[ctxBirthDate.field]"
        [submitErrors]="submitErrors.asObservable()"
      >
        <calendar-input
          [id]="ctxBirthDate.field"
          [ctrl]="ctxBirthDate.control"
          [isNested]="true"
          [label]="'profile-identity.field.birth-date' | translate"
          [max]="maxDate"
          [min]="minDate"
          [readonly]="false"
          (dateChange)="trackDateInputEvent()"
          data-e2e-element="identity.input.birthdate"
        ></calendar-input>
      </app-form-field>
    }
    @let ctxCountry = { focus: false, control: form.get('country'), field: 'country' };
    @if (ctxCountry) {
      <app-form-field
        [isControlTouched]="ctxCountry.control.touched"
        [errors]="ctxCountry.control.errors"
        [errorTexts]="fieldErrors[ctxCountry.field]"
        [submitErrors]="submitErrors.asObservable()"
      >
        <label
          [for]="ctxCountry.field"
          [class.fade-in]="ctxCountry.control.value || ctxCountry.focus"
          translate="profile-identity.field.residence-country"
        ></label>
        <global-country-select
          [labelForId]="ctxCountry.field"
          [loadingText]="'profile-identity.label.loading-countries' | translate"
          [formControlName]="ctxCountry.field"
          [placeholder]="'profile-identity.field.residence-country' | translate"
          [notFoundText]="'profile-identity.alert.unknown-country' | translate"
          (focus)="ctxCountry.focus = true"
          (blur)="ctxCountry.focus = false"
        ></global-country-select>
      </app-form-field>
    }
    <btn
      [loading]="isPending$ | async"
      type="submit"
      buttonText="verification.basic.name.button"
    ></btn>
  </form>
</card-wrapper>
